import React from 'react';

const NoMatch = () => {
    return (
        <div style={{textAlign: 'center'}}>
            <h2>Page not found</h2>
            <h3>Error: 404</h3>
        </div>
    );
};

export default NoMatch;